module.exports = __webpack_public_path__ + "media/82.8bb44b2f.mp3";